import { Button } from "@/shared/components/ui/button";
import { Card } from "@/shared/components/ui/card";
import { Input } from "@/shared/components/ui/input";
import { Switch } from "@/shared/components/ui/switch";
import { useState } from "react";
import type { PrismConfigBoolItem, PrismConfigIntItem } from "../types/preferences_types";


export function ConfigGroup({
    title,
    children,
}: {
    title: string;
    children: React.ReactNode;
}) {
    return (
        <div className="space-y-3">
            <div className="text-base font-semibold">{title}</div>
            <Card className="p-4">
                <div className="flex flex-col gap-4">{children}</div>
            </Card>
        </div>
    );
}

export function BoolConfigRow({
    item,
    onChange,
    canWrite,
  }: {
    item: PrismConfigBoolItem;
    onChange: (next: boolean) => void;
    canWrite: boolean;
  }) {
    return (
        <div className="space-y-2">
            <div>
                <div className="font-medium">{item.label}</div>
                {item.tooltip && (
                    <div className="mt-1 text-sm text-muted-foreground">{item.tooltip}</div>
                )}
            </div>
            <div>
                <Switch checked={item.value} onCheckedChange={onChange} disabled={!canWrite} />
            </div>
        </div>
    );
  }

export function IntConfigRow({
    item,
    onSave,
    canWrite,
}: {
    item: PrismConfigIntItem;
    onSave: (next: number) => void;
    canWrite: boolean;
}) {
    const [temp, setTemp] = useState(String(item.value));

    return (
        <div className="space-y-2">
            <div>
                <div className="font-medium">{item.label}</div>
                {item.tooltip && (
                    <div className="mt-1 text-sm text-muted-foreground">{item.tooltip}</div>
                )}
            </div>
            <div className="flex items-center gap-2">
                <Input
                    type="number"
                    min={item.min ?? 1}
                    className="h-9 w-[110px]"
                    value={temp}
                    onChange={(e) => setTemp(e.target.value)}
                />
                <Button className="h-9" onClick={() => onSave(Number(temp))} disabled={!canWrite}>
                    변경
                </Button>
            </div>
        </div>
    );
}
